import React from "react";
import PropTypes from "prop-types";
import StickyNav from "~components/molecules/sticky_nav/sticky_nav";
import { BLOK_ARRAY } from "../../../../../prop_types";
import TOCChaptersModalController from "../toc_chapters_modal_controller/toc_chapters_modal_controller";
import TOCDownloadModalController from "../toc_download_modal_controller/toc_download_modal_controller";
import { wrapperStyle } from "./toc_nav_mobile.module.scss";

function TOCNavMobile({
  allChaptersTitle,
  chapters,
  collectionTitle,
  currentChapterIndex,
  downloadButtonText,
  downloadFormDescription,
  downloadFormId,
  downloadFormTitle,
  lang,
  pagePath,
}) {
  return (
    <StickyNav>
      <div className={wrapperStyle}>
        <TOCChaptersModalController
          {...{
            chapters,
            currentChapterIndex,
            collectionTitle,
            isNavExpanded: true,
            isSmall: true,
            allChaptersTitle,
            pagePath,
          }}
        />
        {downloadFormId && (
          <TOCDownloadModalController
            {...{
              downloadButtonText,
              downloadFormId,
              downloadFormTitle,
              downloadFormDescription,
              lang,
              isNavExpanded: true,
              isSmall: true,
            }}
          />
        )}
      </div>
    </StickyNav>
  );
}

TOCNavMobile.propTypes = {
  activeItem: PropTypes.string,
  allChaptersTitle: PropTypes.string,
  chapters: BLOK_ARRAY,
  collectionTitle: PropTypes.string,
  currentChapterIndex: PropTypes.number,
  downloadButtonText: PropTypes.string,
  downloadFormDescription: PropTypes.string,
  downloadFormId: PropTypes.string,
  downloadFormTitle: PropTypes.string,
  isVisible: PropTypes.bool,
  lang: PropTypes.string,
  pagePath: PropTypes.string,
  sections: BLOK_ARRAY,
};

TOCNavMobile.defaultProps = {
  activeItem: null,
  allChaptersTitle: null,
  chapters: null,
  collectionTitle: null,
  currentChapterIndex: null,
  downloadButtonText: null,
  downloadFormDescription: null,
  downloadFormId: null,
  downloadFormTitle: null,
  isVisible: false,
  lang: "en-gb",
  pagePath: null,
  sections: null,
};

export default TOCNavMobile;
